import React from 'react';
import { Typography } from '@mui/material';

import { PRIME_CDN_URL } from 'constants/environments';
import { customHeapEvent } from 'utils/heap';

import type { IntegrationsCheckboxCardProps } from './IntegrationsCheckboxCard';
import { IntegrationsCheckboxCard } from './IntegrationsCheckboxCard';

const learnMoreUrl = 'https://sellersshield.com/home/contact/';

export function SellersShieldCheckboxCard(props: IntegrationsCheckboxCardProps) {
  React.useEffect(() => {
    customHeapEvent('Forms - Onboard Modal - Sellers Shield Shown');
  }, []);

  return (
    <IntegrationsCheckboxCard {...props}>
      <img
        src={`${PRIME_CDN_URL}/prime/images/SellersShieldLogo.png`}
        id="sellersShieldLogo"
        alt="Sellers Shield"
        width="auto"
        height={30}
      />
      <Typography className="text-sm text-left text-grey-800">
        Help sellers complete disclosure forms and protect yourself with legal support, minimizing dispute risks.{' '}
        <a target="_blank" rel="noopener" href={learnMoreUrl}>
          Learn More.
        </a>
      </Typography>
    </IntegrationsCheckboxCard>
  );
}
